import { render } from "./doubleInputVFor.vue?vue&type=template&id=63d38162&lang=pug"
import script from "./doubleInputVFor.vue?vue&type=script&lang=js"
export * from "./doubleInputVFor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/doubleInputVFor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63d38162"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63d38162', __exports__)) {
    api.reload('63d38162', __exports__)
  }
  
  module.hot.accept("./doubleInputVFor.vue?vue&type=template&id=63d38162&lang=pug", () => {
    api.rerender('63d38162', render)
  })

}


export default __exports__